var _rect, _path, _rect2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 5.3335H5.21212C4.59851 5.3335 4 5.93956 4 6.5835V17.4547C4 18.0684 4.60606 18.6668 5.21212 18.6668H10.6667V18.0608H5.21212C4.90909 18.0608 4.60606 17.7577 4.60606 17.4547V6.54562C4.60606 6.24259 4.90909 5.93956 5.21212 5.93956H10.6667V5.3335ZM10.6667 6.54562H5.81818C5.51515 6.54562 5.21212 6.84865 5.21212 7.15168V15.6365L9.45455 10.788L10.6667 12.4042V6.54562Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6666,
    y: 4,
    width: 1.33333,
    height: 16,
    rx: 0.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 18.6668H18.7879C19.394 18.6668 20 18.0684 20 17.4547V6.54562C20 5.93956 19.4015 5.3335 18.7879 5.3335H13.3334V5.93956H18.7879C19.0909 5.93956 19.394 6.24259 19.394 6.54562V17.4547C19.394 17.7577 19.0909 18.0608 18.7879 18.0608H13.3334V18.6668Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5186 17.0695C18.402 17.2164 18.2246 17.3202 18.0472 17.3202H13.3334L13.3334 13.4818L13.3334 12.3707L14.4108 11.2596L18.0472 14.896L18.5186 15.3337C18.5186 15.2154 18.5186 15.704 18.5186 15.704V17.0695Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7593 7.92627C16.7593 8.61662 16.1997 9.17627 15.5093 9.17627C14.8189 9.17627 14.2593 8.61662 14.2593 7.92627C14.2593 7.23591 14.8189 6.67627 15.5093 6.67627C16.1997 6.67627 16.7593 7.23591 16.7593 7.92627Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareMode);
export default __webpack_public_path__ + "static/media/CompareMode.002b5f5b60d670edfc56d510e58eb9a4.svg";
export { ForwardRef as ReactComponent };